import React, { useState } from "react";

import {
  Container,
  Row,
  Col,
  Nav,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

//About Images
import testImg01 from "../../../assets/images/about/img-02.jpg";
import testImg02 from "../../../assets/images/about/img-03.jpg";
import testImg03 from "../../../assets/images/about/img-04.jpg";
import testImg04 from "../../../assets/images/about/img-05.jpg";

const CompanyTestimonal = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <React.Fragment>
      <section className="section section-lg pt-lg-5 pb-lg-5">
        <Container>
          <Row className="align-items-center gy-4">
            <Col lg={5} className="pe-lg-4 pe-xl-5">
              <div className="section-title mb-5 mb-lg-0">
                <h4 className="title mb-4">Nuestros servicios</h4>
                <h5 className="text-muted mb-4" style={{ fontWeight: 500, fontSize: "1.1rem" }}>
                  ¿Buscas optimizar la gestión de tu personal y fortalecer tu equipo de trabajo?
                </h5>
                <p className="text-muted mb-4">
                  En Avanza Empleo brindamos soluciones integrales en Gestión Humana, diseñadas para apoyar a las empresas en cada etapa del ciclo laboral, garantizando procesos eficientes, confiables y alineados con la normatividad vigente.
                </p>
                <p className="text-muted mb-3 mt-4"><strong>Nuestros servicios incluyen:</strong></p>
                <ul className="list-unstyled about-list text-muted mt-2 mb-4">
                  <li className="mb-2">Reclutamiento y atracción de talento calificado, acorde a las necesidades de tu organización.</li>
                  <li className="mb-2">Selección por competencias, con aplicación de pruebas psicotécnicas y evaluaciones especializadas.</li>
                  <li className="mb-2">Estudios de seguridad y visitas domiciliarias, orientados a procesos de selección confiables.</li>
                  <li className="mb-2">Desarrollo, estructuración e implementación del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST).</li>
                  <li className="mb-2">Aplicación de la batería de riesgos psicosocial, conforme a la normatividad vigente.</li>
                  <li className="mb-2">Publicación y gestión de vacantes a través de nuestra plataforma digital.</li>
                  <li className="mb-2">Afiliaciones a seguridad social para empresas e independientes.</li>
                  <li className="mb-2">Organización y archivo digital de la información de los empleados.</li>
                  <li className="mb-2">Outsourcing completo de Gestión Humana, para una administración laboral integral.</li>
                </ul>
                <p className="text-muted mt-4 mb-0">
                  Con Avanza Empleo, optimizas tiempos y costos, reduces riesgos legales y te enfocas en lo más importante: hacer crecer tu negocio.
                </p>
                <div className="d-flex align-items-center justify-content-between mt-5 pt-2">
                  <div>
                    <Link to="/contact" className="btn btn-outline-primary">
                      Ver Más <i className="uil uil-angle-right-b ms-1"></i>
                    </Link>
                  </div>
                  <ul className="list-inline about-social-menu mb-0">
                    <li className="list-inline-item">
                      <Link to="/" className="">
                        <i className="uil uil-facebook-f"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/" className="">
                        <i className="uil uil-twitter"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/" className="">
                        <i className="uil uil-whatsapp"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/" className="">
                        <i className="uil uil-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <Row>
                <Col md={3}>
                  <Nav
                    tabs
                    className="about-testimonial-menu nav flex-sm-column flex-row nav-pills me-3"
                  >
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg01} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg02} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                        toggle("3");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg03} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "4" })}
                      onClick={() => {
                        toggle("4");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg04} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                  </Nav>
                </Col>

                <Col md={9}>
                  <TabContent
                    className="about-tab-content h-100"
                    activeTab={activeTab}
                  >
                    <TabPane
                      tabId="1"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg01})` }}
                    ></TabPane>
                    <TabPane
                      tabId="2"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg02})` }}
                    ></TabPane>
                    <TabPane
                      tabId="3"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg03})` }}
                    ></TabPane>
                    <TabPane
                      tabId="4"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg04})` }}
                    ></TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default CompanyTestimonal;
